import { memo } from 'react';
import { useHistory } from 'react-router-dom';
import { Popover } from '@mui/material';
import NotificationContentBody from 'app/components/Portfolio/NotificationContentBody';
import { useBreadcrumbManager } from '../Common/Breadcrumb';
import { openInNewTab } from 'utils/GenericFunctions';

import { GetNotificationsResult } from 'types/ApiServicesTypes';
import useReadNotifications from 'services/common/useReadNotifications';
import useReadAllNotifications from 'services/common/useReadAllNotifications';
import useGetBrokerAuthUrl from 'services/Menu/useGetBrokerAuthUrl';

const NotificationPopover = ({
  open,
  handleClose,
  unreadCount,
  notificationsData,
  loading,
  anchorEl,
}: {
  open: boolean;
  handleClose: () => void;
  notificationsData: GetNotificationsResult | undefined;
  unreadCount: number;
  loading: boolean;
  anchorEl: HTMLButtonElement | null;
}) => {
  const breadcrumb = useBreadcrumbManager();
  const history = useHistory();

  // Api calling for read notification
  const mutation = useReadNotifications();
  // Api calling for read all notification
  const mutationReadAll = useReadAllNotifications();
  const mutationGetBrokerAuthUrl = useGetBrokerAuthUrl();

  const handleCloseModal = () => {
    handleClose();
  };

  const handleItemClick = (
    id: number,
    type?: string,
    subscriptionId?: number,
    redirectUrl?: string,
    notificationType?: string,
    brokerId?: number,
  ) => {
    handleClose();
    breadcrumb.resetBreadcrumpPaths();
    mutation.mutate({ id });

    switch (notificationType) {
      case '0':
      case '1':
        history.push(`/portfolio/${type}/${subscriptionId}`);
        break;
      case '2':
      case '6':
      case '7':
      case '9':
      case '10':
        if (redirectUrl) history.push(redirectUrl);
        break;
      case '3':
      case '4':
        if (redirectUrl) {
          if (redirectUrl.startsWith('http')) openInNewTab(redirectUrl);
          else history.push(redirectUrl);
        }
        break;
      case '5':
        if (brokerId) mutationGetBrokerAuthUrl.mutate({ id: brokerId });
        break;
    }
  };

  const handleReadAll = () => {
    mutationReadAll.mutate();
  };

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={handleClose}
      disableScrollLock={true}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      PaperProps={{
        sx: {
          width: '375px',
          pb: 2,
          top: '56px!important',
          borderRadius: 2,
          maxHeight: 'calc(100% - 72px)',
        },
      }}
    >
      <NotificationContentBody
        loading={loading}
        unreadCount={unreadCount}
        handleReadAll={handleReadAll}
        notificationsData={notificationsData}
        handleItemClick={handleItemClick}
        handleCloseModal={handleCloseModal}
      />
    </Popover>
  );
};

export default memo(NotificationPopover);
